// extracted by mini-css-extract-plugin
export default {"partners":"partners_partners__2KZzD","content":"partners_content__2JVLY","logo":"partners_logo__gA8vt"};